module.exports = __webpack_public_path__ + "img/Ellipse3.30b5ae24.png";